export const apiUrl = window.httpApiHostUrl
